import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import Navbar from './Navbar';
import Footer from './Footer';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

const TreePlantationCausePage: React.FC = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });

    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 500);
    }

    const backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          (backToTop as HTMLElement).style.display = 'block';
        } else {
          (backToTop as HTMLElement).style.display = 'none';
        }
      };

      window.addEventListener('scroll', handleScroll);

      backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <>
      <div
        id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div className="spinner-grow text-primary" role="status"></div>
      </div>

      <Navbar />

      <div
        className="container-fluid page-header causes-page-header mb-5"
        data-aos="fade"
        data-aos-delay="100"
        style={{ background: `linear-gradient(rgba(0, 29, 35, .75), rgba(0, 29, 35, .75)), url("${mediaUrl('Photo from Anand Mashatte(47).jpg')}") center center / cover no-repeat` }}
      >
        <div className="container text-center">
          <h1 className="display-4 text-white animated slideInDown mb-4" data-aos="fade-down">
            Plant Trees, Save Lives
          </h1>
          <nav aria-label="breadcrumb animated slideInDown" data-aos="fade-down" data-aos-delay="200">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/causes" className="text-white">
                  Causes
                </Link>
              </li>
              <li className="breadcrumb-item text-primary active" aria-current="page">
                Tree Plantation
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
              <img className="img-fluid rounded w-100" src={mediaUrl('courses-2.jpg')} alt="Tree Plantation Drive" />
            </div>
            <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
              <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">Tree Plantation</div>
              <h2 className="mb-4">Restoring nature and protecting communities in India</h2>
              <p className="mb-3">
                Our tree plantation initiative supports cleaner air, healthier soil, and stronger ecosystems in cities and
                rural communities across India.
              </p>
              <p className="mb-3">
                We organize plantation drives in schools, villages, and public spaces, while also ensuring post-plantation
                care such as watering, fencing, and community ownership.
              </p>
              <p className="mb-4">
                Each sapling planted contributes to climate resilience, reduced heat impact, and a greener future for children
                and families.
              </p>
              <a
                className="btn btn-primary py-2 px-3 me-3"
                href={DONATE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Donate Now
                <div className="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2">
                  <i className="fa fa-arrow-right"></i>
                </div>
              </a>
              <Link to="/causes" className="btn btn-outline-primary py-2 px-3">
                Back to Causes
                <div className="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2">
                  <i className="fa fa-arrow-right"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <button type="button" className="btn btn-lg btn-primary btn-lg-square back-to-top" aria-label="Back to top">
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
};

export default TreePlantationCausePage;
